<template>
  <div class="catalogue-page">
    <!-- 正文控制台 -->
    <div class="text-control">
      <!-- 头部 -->
      <div class="header" :class="{ active: controlShow }">
        <div class="left">
          <van-icon name="arrow-left" size="22px" @click="exitText" />
          <span>{{ BookTitle }}</span>
        </div>
        <div class="right">
          <van-icon name="friends" />
          <van-icon name="wap-home" @click="$router.push({ path: '/' })" />
          <van-icon name="column" @click="$router.push({ path: '/bookshelf' })" />
          <van-icon name="weapp-nav" />
        </div>
      </div>
      <!-- 中部 加入书架 -->
      <div class="push-bookshelf" :class="{ active: controlShow }" @click="addIntoBookshelf">
        <van-icon>
          <img src="../assets/push.png" alt />
        </van-icon>
        <span>加入书架</span>
      </div>
      <!-- 已添加书籍 -->
      <div class="message-info" v-show="visible" :class="{ active: visible }">已添加《 {{ BookTitle }} 》</div>
      <!-- 尾部 -->
      <div class="footer" :class="{ active: controlShow }">
        <van-tabbar v-model="active">
          <van-tabbar-item @click="pushCatalogueList">
            <img slot="icon" src="../assets/bars.png" />
          </van-tabbar-item>

          <van-tabbar-item v-if="isNght" @click="changIsNight">
            <img slot="icon" src="../assets/sun.png" />
          </van-tabbar-item>
          <van-tabbar-item v-else @click="changIsNight">
            <img slot="icon" src="../assets/moon.png" />
          </van-tabbar-item>

          <van-tabbar-item @click="getSetting">
            <img slot="icon" src="../assets/setting.png" />
          </van-tabbar-item>
          <van-tabbar-item>
            <img slot="icon" src="../assets/down.png" />
          </van-tabbar-item>
        </van-tabbar>
      </div>
    </div>

    <!-- 正文弹出目录 -->
    <van-popup
      v-model="textBookChaptersShow"
      position="left"
      :style="{ width: '80%', height: '100%' }"
    >
      <van-nav-bar :title="BookTitle">
        <van-icon name="ascending" slot="right" v-if="isReverse" @click="changeIsReverse" />
        <van-icon name="descending" slot="right" v-else @click="changeIsReverse" />
      </van-nav-bar>

      <ul class="book-chapters" v-if="BookChapters">
        <li
          v-for="(item, index) in BookChapters"
          :key="index"
          @click="getTextContent(index)"
        >{{ item.title }}</li>
        <!-- {{ index + 1 }} . -->
      </ul>
    </van-popup>

    <!-- 设置框 -->
    <div class="setting-control" :class="{ active: showSettingCon }">
      <div class="light">
        <van-icon name="bulb-o" size="16px" />
        <div class="slider">
          <van-slider v-model="sliderValue" :min="-100" :max="0" @input="onInput" />
        </div>
        <van-icon name="bulb-o" size="24px" />
      </div>

      <div class="text-size">
        <span @click="fontSmaller">Aa-</span>
        <span @click="fontNormal">Aa</span>
        <span @click="fontBigger">Aa+</span>
      </div>
      <div class="text-family">
        <span @click="changeFamilyKai('正楷')">正楷</span>
        <span @click="changeFamilySong('宋体')">宋体</span>
        <span @click="changeFamilyLi('隶书')">隶书</span>
      </div>
      <div class="bg-color">
        <span style="background: #E5C9A1" @click="changeColorOne('#E5C9A1')"></span>
        <span style="background: #FBCFD2" @click="changeColorTwo('#FBCFD2')"></span>
        <span style="background: #C8EDCC" @click="changeColorThree('#C8EDCC')"></span>
        <span style="background: #F0F0F0" @click="changeColorFour('#F0F0F0')"></span>
        <span style="background: #1A1A1A" @click="changeColorFive('#1A1A1A')"></span>
      </div>
      <div class="capacity-function"></div>
    </div>

    <!-- 正文 -->
    <div class="interface-controls" v-if="textShow && TextContent">
      <div class="next-pages" @click.prevent="nextPages"></div>
      <div class="middle-control" @click.prevent="showTextControl"></div>
      <div class="previous-pages" @click.prevent="previousPages"></div>
      <div class="mask" :style="{ opacity: -sliderValue / 100 }"></div>
    </div>
    <div
      class="text-content"
      v-if="textShow && TextContent"
      @click="showTextControl"
      :style="{ 'font-size': size + 'px' }"
      @scroll="handleScroll"
    >
      <div class="texts">
        <!-- <div class="next-pages" @click.prevent="nextPages"></div>
        <div class="previous-pages" @click.prevent="previousPages"></div>
        <div class="mask" :style="{ opacity: -sliderValue / 100 }"></div>-->
        <!-- :style="{background: rgba(0,0,0,sliderValue/100)}" -->

        <span class="content-title">{{ TextContent.title }}</span>
        <p v-for="(item, index) in TextContentArr" :key="index">{{ item }}</p>
        <div class="control-chapter">
          <!-- <span class="previous-chapter" @click.prevent.stop="getPreviousChapter">上一章</span> -->
          <!-- <span class="next-chapter" @click.prevent.stop="getNextChapter">下一章</span> -->
        </div>
      </div>
    </div>
    <!-- 目录 -->
    <!-- $store.state.bookDetailId -->
    <template v-else>
      <van-nav-bar
        :title="BookTitle"
        left-arrow
        @click-left="$router.go(-1)"
        style="background:#ffffff"
      >
        <van-icon name="ascending" slot="right" v-if="isReverse" @click="changeIsReverse" />
        <van-icon name="descending" slot="right" v-else @click="changeIsReverse" />
      </van-nav-bar>

      <ul class="book-chapters" v-if="BookChapters">
        <li
          v-for="(item, index) in BookChapters"
          :key="index"
          @click="getTextContent(index)"
        >{{ item.title }}</li>
        <!-- {{ index + 1 }} . -->
      </ul>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
      BookSources: null,
      BookChapters: null,
      BookTitle: null,
      isReverse: false,
      TextContent: null,
      TextContentArr: null,
      TextArr: null,
      textShow: false,
      isNght: false,
      controlShow: false,
      visible: false,
      textBookChaptersShow: false,
      showSettingCon: false,
      sliderValue: -30,
      size: 16,
      chapter: null,
      translateXMove: 0,
      startPages: 0
    };
  },
  computed: {
    $route: function() {
      this.getBookSources();
      this.getBookTitle();
      return null;
    }
  },
  methods: {
    nextPages() {
      // this.controlShow = !this.controlShow;
      // this.showSettingCon = false;

      let content = document.querySelector(".texts");
      this.translateXMove = this.translateXMove - 100;
      content.style.transform = "translateX(" + this.translateXMove + "vw)";
      this.startPages++;
      //粗略判断
      if (this.startPages > 5) {
        this.getNextChapter();
      }
    },
    previousPages() {
      // this.controlShow = !this.controlShow;
      // this.showSettingCon = false;
      if (this.translateXMove < 0) {
        this.startPages--;
        let content = document.querySelector(".texts");
        this.translateXMove = this.translateXMove + 100;
        content.style.transform = "translateX(" + this.translateXMove + "vw)";
      }
    },
    getNextChapter() {
      //   let index = this.chapter;
      //   index >= this.BookChapters.length - 1 ? index : ++index;
      //   this.getTextContent(index);

      this.textShow = true;
      this.textBookChaptersShow = false;
      this.controlShow = false;
      this.chapter = this.chapter + 1;
      let url = encodeURIComponent(this.BookChapters[this.chapter].link);
      let content = document.querySelector(".texts");
      // let content = document.querySelector(".text-content");
      let chapter = document.querySelector(".control-chapter");

      // window.console.log(url);
      this.axios
        .get("https://novel.kele8.cn/chapters/" + url)
        .then(response => {
          // this.$toast.loading({
          //   message: "加载中...",
          //   forbidClick: true,
          //   loadingType: "spinner"
          // });
          // window.console.log(response.data.chapter.cpContent);
          this.TextContent = response.data.chapter;
          this.TextArr = this.TextContent.cpContent.split("\r\n");
          let title = document.createElement("span");
          title.innerText = this.TextContent.title;
          content.insertBefore(title, chapter);
          //   this.TextContentArr.push(this.TextContent.title);
          for (let index = 0; index < this.TextArr.length; index++) {
            this.TextContentArr.push(this.TextArr[index]);
          }
        });
    },
    onInput(value) {
      // this.$toast("当前值：" + value);
      window.console.log(value);
    },
    fontNormal() {
      this.size = 16;
    },
    fontSmaller() {
      if (this.size > 1) {
        this.size -= 1;
      } else {
        return;
      }
    },
    fontBigger() {
      this.size += 1;
    },
    changeFamily(style) {
      let contents = document.querySelector(".texts");
      let content = document.querySelector(".text-content");
      contents.style.fontFamily = style;
      content.style.fontFamily = style;
    },
    changeFamilyKai(style) {
      this.changeFamily(style);
    },
    changeFamilySong(style) {
      this.changeFamily(style);
    },
    changeFamilyLi(style) {
      this.changeFamily(style);
    },
    changeColor(color) {
      let contents = document.querySelector(".texts");
      let content = document.querySelector(".text-content");
      contents.style.background = color;
      content.style.background = color;
    },
    changeColorOne(color) {
      this.changeColor(color);
    },
    changeColorTwo(color) {
      this.changeColor(color);
    },
    changeColorThree(color) {
      this.changeColor(color);
    },
    changeColorFour(color) {
      this.changeColor(color);
    },
    changeColorFive(color) {
      this.changeColor(color);
    },
    addIntoBookshelf() {
      this.controlShow = !this.controlShow;
      this.visible = true;
      this.showSettingCon = false;

      setTimeout(() => {
        this.visible = false;
      }, 1700);
    },
    changIsNight() {
      let contents = document.querySelector(".texts");
      let content = document.querySelector(".text-content");

      if (this.isNght == false) {
        content.style.background = "#121212";
        content.style.color = "#888888";
        contents.style.background = "#121212";
        contents.style.color = "#888888";
        this.isNght = true;
      } else {
        content.style.background = "#F8EEEB";
        content.style.color = "#333333";
        contents.style.background = "#F8EEEB";
        contents.style.color = "#333333";
        this.isNght = false;
      }
    },
    getSetting() {
      this.showSettingCon = true;
    },
    pushCatalogueList() {
      this.textBookChaptersShow = true;
    },
    showTextControl() {
      this.controlShow = !this.controlShow;
      this.showSettingCon = false;
    },
    exitText() {
      this.textShow = false;
      this.controlShow = false;
      this.showSettingCon = false;
    },
    changeIsReverse() {
      this.isReverse = !this.isReverse;
      this.BookChapters = this.BookChapters.reverse();
    },
    getBookSources() {
      this.axios
        .get(
          "https://novel.kele8.cn/book-sources?view=summary&book=" +
            this.$store.state.bookDetailId
        )
        .then(response => {
          // window.console.log(response.data);
          this.$toast.loading({
            message: "加载中...",
            forbidClick: true,
            loadingType: "spinner"
          });
          this.BookSources = response.data[0]._id;
          this.getBookChapters();
        })
        .finally(this.$toast.clear());
    },
    getBookChapters() {
      this.axios
        .get("https://novel.kele8.cn/book-chapters/" + this.BookSources)
        .then(response => {
          this.$toast.loading({
            message: "加载中...",
            forbidClick: true,
            loadingType: "spinner"
          });
          window.console.log(response.data);
          this.BookChapters = response.data.chapters;
        })
        .finally(this.$toast.clear());
    },
    //将文本改成每个段落
    getBookTitle() {
      this.axios
        .get(
          "https://novel.kele8.cn/book-info/" + this.$store.state.bookDetailId
        )
        .then(response => {
          // window.console.log(response.data);
          this.BookTitle = response.data.title;
        });
    },
    getTextContent(index) {
      window.console.log("Gun");
      this.translateXMove = 0;
      this.TextContent = null;
      this.TextContentArr = null;
      this.textShow = true;
      this.textBookChaptersShow = false;
      this.controlShow = false;
      this.chapter = index;
      let url = encodeURIComponent(this.BookChapters[this.chapter].link);
      // window.console.log(url);
      this.axios
        .get("https://novel.kele8.cn/chapters/" + url)
        .then(response => {
          this.$toast.loading({
            message: "加载中...",
            forbidClick: true,
            loadingType: "spinner"
          });
          // window.console.log(response.data.chapter.cpContent);
          this.TextContent = response.data.chapter;
          this.TextContentArr = this.TextContent.cpContent.split("\r\n");
        })
        .finally(this.$toast.clear());
    },
    handleScroll() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      var windowHeitht =
        document.documentElement.clientHeight || document.body.clientHeight;
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      //是否滚动到底部的判断
      if (scrollTop + windowHeitht >= scrollHeight - 50) {
        // this.getSpecialData();
        window.console.log("滚动");
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    // ...
    next(vm => {
      vm.getBookSources();
      vm.getBookTitle();
    });
  },
  mounted(index) {
    window.addEventListener("scroll", this.getTextContent(index));
  }
};
</script>

<style lang="less" scope>
.catalogue-page {
  .header {
    &.active {
      top: 0px;
    }
    position: fixed;
    top: -45px;
    // top: 0;
    left: 0;
    width: 100%;
    background: #444545;
    display: flex;
    padding: 8px;
    color: #e6e6e6;
    z-index: 9;
    transition: all 0.3s;
    .left {
      flex: 1;
      .van-icon {
        top: 4px;
      }
      span {
        font-size: 18px;
        margin-left: 10px;
      }
    }
    .right {
      display: flex;
      flex: 1;
      padding-right: 5px;
      .van-icon {
        flex: 1;
        font-size: 25px;
        text-align: center;
      }
    }
  }
  .push-bookshelf {
    &.active {
      right: 0;
    }
    background: #444545;
    padding: 15px 10px;
    border-radius: 50px 0 0 50px;
    position: fixed;
    top: 50%;
    right: -115px;
    z-index: 9;
    display: flex;
    transform: translate(0, -50%);
    transition: all 0.3s;
    .van-icon {
      width: 20px;
      img {
        width: 100%;
        display: block;
      }
    }
    span {
      margin-left: 10px;
      flex: 1;
      color: #e6e6e6;
    }
  }
  @keyframes mymove {
    0% {
      bottom: 0;
    }
    50% {
      bottom: 20%;
    }
    75% {
      opacity: 1;
    }
    100% {
      bottom: 20%;
      opacity: 0;
    }
  }
  .message-info {
    &.active {
      animation: mymove 2s ease 1;
    }
    position: fixed;
    padding: 5px 10px;
    border-radius: 15px;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0);
    background: #999;
    z-index: 9;
    color: #ffffff;
    transform: all 0.3s;
    opacity: 1;
  }
  .setting-control {
    &.active {
      bottom: 0;
    }
    position: fixed;
    width: 100%;
    height: 30vh;
    bottom: -250px;
    left: 0;
    z-index: 9;
    background: #444545;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    text-align: center;
    color: #e6e6e6;
    transform: all 0.3s;
    padding: 10px;
    box-sizing: border-box;
    // line-height: 100px;
    .light {
      padding: 3px 0 15px;
      .van-icon {
        &:last-child {
          transform: translate(10px, 6px);
        }
        &:first-child {
          transform: translate(-10px, 3px);
        }
      }
      .slider {
        width: 75%;
        display: inline-block;
        // transform: translate(-10%,0);
        .van-slider {
        }
      }
    }
    .text-size {
      flex: 1;
      display: flex;
      padding: 8px;
      box-sizing: border-box;
      span {
        flex: 1;
        height: 30px;
        border-radius: 15px;
        border: 1px solid #999;
        margin: 0 20px;
        line-height: 30px;
        // &:nth-child(2) {
        //     border: none;
        //     font-size: 18px;
        //     letter-spacing: 2px;
        // }
      }
    }
    .text-family {
      flex: 1;
      display: flex;

      span {
        flex: 1;
        height: 35px;
        border-radius: 15px;
        border: 1px solid #999;
        margin: 0 15px;
        line-height: 35px;
      }
    }
    .bg-color {
      flex: 1;
      display: flex;

      span {
        flex: 1;
        height: 40px;
        border: 1px solid #999;
        border-radius: 10px;
        margin: 10px 5px;
      }
    }
  }
  .footer {
    &.active {
      .van-tabbar--fixed {
        bottom: 0px;
      }
    }
    position: relative;
    z-index: 9;

    .van-tabbar--fixed {
      background: #444545;
      bottom: -50px;
      // bottom: 0;
      transition: all 0.3s;
      .van-tabbar-item {
        img {
          transform: scale(1.3);
        }
      }
    }
  }

  .van-nav-bar {
    .van-icon-ascending,
    .van-icon-descending {
      font-size: 25px;
      color: #999;
    }
    .van-nav-bar__arrow {
      font-size: 25px;
      color: #999;
    }
    .van-nav-bar__title {
      font-size: 20px;
      letter-spacing: 1px;
      color: #666;
      font-weight: 600;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
    }
  }
  ul.book-chapters {
    margin-bottom: 50px;
    li {
      padding: 15px;
      font-size: 16px;
      color: #333;
      border-bottom: 1px solid rgb(245, 245, 245);
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
    }
  }
  .interface-controls {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 2;
    .next-pages,
    .previous-pages,
    .middle-control {
      position: fixed;
      top: 0;
      width: 33%;
      height: 100vh;
      // background: red;
      opacity: 0.5;
      z-index: 1;
    }
    .next-pages {
      right: 0;
    }
    .middle-control {
      left: 33%;
    }
    .previous-pages {
      left: 0;
    }
    .mask {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
      background: rgba(0, 0, 0, 0.8);
      // opacity: 1;
      z-index: 1;
      pointer-events: none;
    }
  }

  .text-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 1;
    background: #f8eeeb;
    overflow: hidden;
    font-family: "正楷"; //隶书/宋体
    letter-spacing: 0.2em;
    color: #333333;
    margin-top: 0;
    white-space: pre-wrap;
    word-wrap: break-word;
    box-sizing: border-box;
    text-indent: 2em;
    .texts {
      // transform: translateX(-50vw);
      columns: 100vw 1;
      column-gap: 6px;
      // column-rule:1px solid rgba(0,0,0,0.1);
      position: absolute;
      top: 0;
      left: 0;
      // width: 100%;
      height: 100vh;
      z-index: 1;
      background: #f8eeeb;
      // overflow: auto;
      font-family: "正楷"; //隶书/宋体
      letter-spacing: 0.2em;
      color: #333333;
      margin-top: 0;
      white-space: pre-wrap;
      word-wrap: break-word;
      padding-left: 6px;
      padding-top: 12px;
      padding-bottom: 12px;
      box-sizing: border-box;
      text-indent: 2em;
      transition: all 0.5s;
      p {
        &:last-of-type {
          margin-bottom: 50px;
        }
      }
      .control-chapter {
        text-align: center;
        text-indent: 0;
        // display: flex;
        span.previous-chapter,
        span.next-chapter {
          // flex: 1;
          display: inline-block;
          margin: 20px;
          border: 1px solid lightgray;
          padding: 5px 10px;
          font-size: 14px;
          background: rgba(0, 0, 0, 0.2);
          position: relative;
          z-index: 99;
        }
      }
      p {
        margin: 10px 0;
      }
      span {
        display: block;
        margin: 20px 0 30px;
        font-size: 18px;
        font-weight: 600;
        text-align: center;
        text-indent: 0;
        &:nth-of-type(n + 2) {
          margin: 100px 0 30px;
        }
      }
    }
  }
}
</style>
